<template>
    <gz-auth-view-template v-if="$store.getters['staffUserview'].attributes">
        <GZ-PageTitle 
            title="Юридическое лицо" 
            slot="title"
        />

        <section slot="under-title">
        </section>

        <section slot="above-content" class="gz-tabs gz-tabs__section">
            <router-link 
                :to="`/admin/service-entity/${$route.params.id}/info`" 
                class="gz-tabs__item"
            >Данные юр лица</router-link>
        </section>

        <section slot="content">
            <router-view></router-view>
        </section>        
    </gz-auth-view-template>
</template>

<script>
export default {
    name: 'ServiceEntitySingle'
}
</script>